angular.module("storefrontApp").service("searchSuggestionSpriteService", function () {
    function getConfig() {
        return window.__searchSuggestionSprites || {};
    }

    function resolveIconCoords(iconName) {
        var config = getConfig();
        var icons = config.icons || {};
        var defaultIcon = config.defaultIcon || "embroideryDesigns";
        return icons[iconName] || icons[defaultIcon] || { x: 0, y: 0 };
    }

    this.getIconStyle = function (iconName, displaySize) {
        var config = getConfig();
        var spriteSize = config.size || 125;
        var columns = config.columns || 8;
        var rows = config.rows || 4;
        var size =
            displaySize ||
            config.displaySize ||
            spriteSize;
        var sourceWidth = columns * spriteSize;
        var sourceHeight = rows * spriteSize;
        var defaultScale = size / spriteSize;
        var sheetWidth =
            config.sheetWidth ||
            sourceWidth * defaultScale;
        var sheetHeight =
            config.sheetHeight ||
            sourceHeight * defaultScale;
        var scaleX = sheetWidth / sourceWidth;
        var scaleY = sheetHeight / sourceHeight;
        var icon = resolveIconCoords(iconName);

        return {
            "background-image": "url('" + config.sprite + "')",
            "background-repeat": "no-repeat",
            "background-size": sheetWidth + "px " + sheetHeight + "px",
            "background-position":
                "-" + icon.x * scaleX + "px -" + icon.y * scaleY + "px",
            width: size + "px",
            height: size + "px",
            display: "block",
        };
    };

    this.getSuggestionIconStyle = function (suggestion, displaySize) {
        var iconName =
            suggestion && suggestion.icon
                ? suggestion.icon
                : getConfig().defaultIcon || "embroideryDesigns";
        return this.getIconStyle(iconName, displaySize);
    };
});
